import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { getCurrentUser,hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';
import { ActivatedRoute } from '@angular/router';
import {    SimuladorService } from '../services/simulador.service';
import { HelpersService } from 'src/app/core/services/helpers.service';

interface ResultadoSimulacion {
  cuotas: string;
  valorCuota: number;
  totalSeguro: number;
  intereses: number;
  financiado: number;
  full: number;
  tasa: number;
  seguro: number;
}

@Component({
    selector: 'app-tasa-preferencial',
    templateUrl: './tasaPreferencial.component.html',
    styleUrls: ['./tasaPreferencial.component.scss']
  })

export class TasaPreferencialComponent implements OnInit {
  
  plazos: { name: string, selected: boolean }[] = [];
  politica: any[] = [];
  selectedPolitica: string = ''; 
  seguro: string = '0';  // Valor inicial
  tasa: string = '0';    // Valor inicial
  cuota: string[] = [];
  valorCuota: string[] = [];
  seguros: string[] = [];
  totalSeguro: string[] = [];
  intereses: string[] = []; 
  financiado: string[] = [];
  full: string[] = [];
  tasas: number[] = []; 
  capital: string; // El valor del campo
  resultados: ResultadoSimulacion[] = [];
  destacado: ResultadoSimulacion | null = null;


  public tasaForm = this.formBuilder.group({
        capital: ["", [Validators.required]]
        })
      constructor(private notificationService: NotificationHelper,
        private notificationHelper: NotificationHelper,
        private helpers: HelpersService,
        private simuladorService: SimuladorService,
        private formBuilder: FormBuilder,
      ) {
        
      }
        // Función para actualizar el valor sin los separadores de miles
      onCapitalChange(value: string) {
        let cleanValue = value.replace(/[^0-9]/g, '');  // Elimina los caracteres no numéricos
        this.capital = cleanValue ? cleanValue : '';  // Actualiza el valor sin formatear
      }
            formatSeguro(value: string): string {
        const usuario = getCurrentUser();
        const empresa = usuario ? usuario.c_emp : 'JA';
        if (!value) {
          return '$0';
        }
        let numValue = parseFloat(value.replace(/[^0-9.]/g, ''));
        let formattedValue: string;
        if (empresa === 'JA') {
          formattedValue = numValue.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        } else if (empresa === 'JP') {
            formattedValue = numValue % 1 === 0
            ? numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            : numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        } else {
          formattedValue = numValue.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return `$${formattedValue}`;
      }
        
      formatTasa(value: string): string {
        if (!value) {
          return '0%';
        }
        let formattedValue = parseFloat(value.replace(/[^0-9.]/g, ''));
        return `${formattedValue.toFixed(2)}%`;
      }
      async traerTasas() {
        try {
          const usuario = getCurrentUser();
          const empresa = usuario ? usuario.c_emp : 'JA';
          const resp: any = await this.simuladorService.tasasPreferencial(empresa || 'JA');

          if (Array.isArray(resp)) {
            // Mapear los plazos para agregar la propiedad 'selected' y 'name'
            this.plazos = resp.map(plazo => ({
              name: plazo,      // Asumiendo que 'plazo' es un número o string
              selected: false   // Inicializamos la propiedad 'selected' en false
            }));
          } else {
            console.error("La respuesta no contiene un array de plazos válido.");
            // Si la respuesta no es válida, usamos un fallback
            this.plazos = resp.map((plazo: number) => ({
              name: plazo.toString(),   // Convertimos el número a string
              selected: false           // Inicializamos la propiedad 'selected' en false
            }));
          }
        } catch (error) {
          this.notificationService.errorMessage("Ocurrió un error desconocido.");
          hideSpinner();
          return;
        }
      }
      // Función que se llama cuando se cambia el estado del checkbox "Seleccionar Todos"
      selectAll(event: any): void {
        const isSelected = event.target.checked;
        this.plazos.forEach(plazo => {
          plazo.selected = isSelected;
        });
      }

      // Función para verificar si todos los checkboxes están seleccionados
      allSelected(): boolean {
        return this.plazos.length > 0 && this.plazos.every(plazo => plazo.selected);
      }

      toggleTodos(): void {
        const seleccionar = !this.allSelected();
        this.plazos.forEach(plazo => plazo.selected = seleccionar);
      }

      plazosSeleccionados(): string[] {
        return this.plazos.filter(plazo => plazo.selected).map(plazo => plazo.name);
      }

      nombrePolitica(): string {
        const item = this.politica.find(p => String(p['CODIGO']) === String(this.selectedPolitica));
        return item ? item['NOM_PARAM'] : '';
      }

      listoParaGuardar(): boolean {
        return !!this.selectedPolitica && this.plazosSeleccionados().length > 0;
      }

      // Quita el símbolo ($ o %) que agregan formatSeguro/formatTasa; la unidad se muestra fija en el input
      sinSimbolo(value: string): string {
        return value.replace(/[$%]/g, '');
      }

      menorCosto(): ResultadoSimulacion | null {
        let menor: ResultadoSimulacion | null = null;
        this.resultados.forEach(r => {
          if (!menor || r.full < menor.full) { menor = r; }
        });
        return menor;
      }

      alturaBarra(r: ResultadoSimulacion): number {
        const max = Math.max(...this.resultados.map(x => x.full));
        return max > 0 ? Math.max(8, (r.full / max) * 100) : 0;
      }

      simular(): void {
        this.simulador();
      }
      async politicaP() {
        try {
          const usuario = getCurrentUser();
          const empresa = usuario ? usuario.c_emp : 'JA';
          const resp: any = await this.simuladorService.politicaPreferencial(empresa || 'JA');
          if (Array.isArray(resp)) {
            this.politica = resp; 
          } else {
            console.error("La respuesta no contiene un array de plazos válido.");
            this.politica = ['Política de tasa preferencial no encontrada']; 
          }
        } catch (error) { 
          this.notificationService.errorMessage("Ocurrió un error desconocido.");
          // Si tienes un spinner para ocultar, asegúrate de llamarlo aquí.
          hideSpinner(); 
        }
    }
    async onSubmit(): Promise<void> {
      try {
      if (!this.seguro.trim() || !this.tasa.trim()) {
        this.notificationService.errorMessage("Los campos 'seguro' y 'tasa' no pueden estar vacíos o contener solo espacios.");
        return;
      }
      const plazoSeleccionados = this.plazos.filter(plazo => plazo.selected).map(plazo => plazo.name);
      if (plazoSeleccionados.length === 0) {
        this.notificationService.errorMessage("Debe seleccionar al menos un plazo.");
        return;
      }
      
      // Verifica si se ha seleccionado una política
      if (!this.selectedPolitica) {
        this.notificationService.errorMessage("Debe seleccionar una política.");
        return;
      }
      showSpinner(`Guardando Registros...`);
      // Quitar el formateo de tasa y seguro
      const seguroSinFormato = this.seguro.replace(/[^0-9.]/g, '');
      const tasaSinFormato = this.tasa.replace(/[^0-9.]/g, '');
      const usuario = getCurrentUser();
      const usuarioId = usuario ? usuario.usuario_aplicativo : 'SADMIN';
      const empresa = usuario ? usuario.c_emp : 'JA';
      const datosGuardados = {
        seguro: seguroSinFormato,
        tasa: tasaSinFormato,
        plazosSeleccionados: plazoSeleccionados,
        politica: this.selectedPolitica,
        usuario: usuarioId // Agrega la política seleccionada al objeto de datos guardados
      };
      const res = await this.simuladorService.actualizarPreferencial(empresa || 'JA', datosGuardados);
      if(!res.success) {
        hideSpinner();
        this.notificationService.errorMessage(res.message);
        return;
          }
        hideSpinner()
        this.notificationService.successMessage("Guardado correctamente")
      } catch (error) {
        console.error(error);
        this.notificationService.errorMessage("Ocurrio un error desconocido.")
        hideSpinner();
        return;
      }
    }
    async simulador() {
      this.cuota = [];
      this.intereses = [];
      this.totalSeguro = [];
      this.valorCuota = [];
      this.financiado = [];
      this.full = [];
      this.tasas = [];
      this.seguros = [];
      this.resultados = [];
      this.destacado = null;
      try {
      if (this.tasaForm.invalid) {
        this.notificationService.errorMessage("El campo 'capital' es obligatorio.");
        return;
      }
      const capital = this.tasaForm.get('capital')?.value;

      if (!this.selectedPolitica) {
        this.notificationService.errorMessage("Debe seleccionar una política.");
        return;
      }
      const datosGuardados = {
        capital: capital,
        politica: this.selectedPolitica,
      };
      showSpinner(`Realizando la simulación...`);
      const usuario = getCurrentUser();
      const empresa = usuario ? usuario.c_emp : 'JA';
      const res = await this.simuladorService.simuladorPreferencial(empresa || 'JA', datosGuardados);
      if(!res.success) {
        hideSpinner();
        this.notificationService.errorMessage(res.message);
      }
        if (res.data && res.data.length > 0) {
          res.data.forEach((item, index) => {
            this.cuota[index] = item["Cuotas"];
            this.valorCuota[index] = item["Valor Cuota"];
            this.totalSeguro[index] = item["Total Seguro"];
            this.intereses[index] = item["Total Intereses"];
            this.financiado[index] = item["Total financiado"];
            this.full[index] = item["Precio Full"];
            this.tasas[index] = item["Tasa"];
            this.seguros[index] = item["Seguro"];
          });
          this.resultados = res.data.map(item => ({
            cuotas: item["Cuotas"],
            valorCuota: Number(item["Valor Cuota"]),
            totalSeguro: Number(item["Total Seguro"]),
            intereses: Number(item["Total Intereses"]),
            financiado: Number(item["Total financiado"]),
            full: Number(item["Precio Full"]),
            tasa: item["Tasa"],
            seguro: Number(item["Seguro"]),
          }));
          this.destacado = this.resultados[0];
          hideSpinner();
          this.notificationService.successMessage("Simulación realizada correctamente.");
        } else {
          hideSpinner();
          this.notificationService.errorMessage("No se ha configurado tasa y seguro para la política seleccionada.");
        }
      // Aquí puedes agregar la lógica adicional que necesites con el valor de 'capital' y 'selectedPolitica'
      } catch (error) {
      console.error("Error en simulador:", error);
      this.notificationService.errorMessage("Ocurrió un error al procesar la simulación.");
      }
    }
    ngOnInit(): void {
      this.politicaP();
      this.traerTasas();
    }
}